"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitlesSlot = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const component_context_1 = require("../../context/component.context");
const typography_title_platform_1 = require("../../typography/typography-title-platform");
const header_subtitle_1 = require("./header-subtitle");
const index_module_css_1 = __importDefault(require("./index.module.css"));
const TitlesSlot = ({ title, subtitle }) => {
    const { isMobile, isResponsive, platform } = (0, react_1.useContext)(component_context_1.AdditionalContext);
    const platformStyles = {
        [index_module_css_1.default.mobile]: isMobile,
        [index_module_css_1.default.responsive]: isResponsive,
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(index_module_css_1.default.wrapper, platformStyles), children: [title && ((0, jsx_runtime_1.jsx)(typography_title_platform_1.TypographyTitlePlatform, { tag: 'h3', view: 'small', color: 'primary', dataTestId: 'title', platform: platform, rowLimit: 3, children: title })), subtitle && (0, jsx_runtime_1.jsx)(header_subtitle_1.HeaderSubtitle, { children: subtitle })] }));
};
exports.TitlesSlot = TitlesSlot;
